(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-login/assets/javascripts/views/gaming-info/gaming-info.js') >= 0) return;  svs.modules.push('/modules/player-login/assets/javascripts/views/gaming-info/gaming-info.js'); 'use strict';

svs.player_login.views.GamingInfo = Marionette.View.extend({
  template(data) {
    return svs.player_login.templates.gaming_info(data);
  },

  regions: {
    gamingLimits: '#gaming-limits',
    gamingHistory: '#gaming-history'
  },
  ui: {
    gamingLimits: 'li[data-tab="gaming-limits"]',
    gamingHistory: 'li[data-tab="gaming-history"]',
    gamingInfo: 'li[data-tab="last-login-time"]'
  },
  events: {
    'click @ui.gamingLimits': 'clickGamingLimits',
    'click @ui.gamingHistory': 'clickGamingHistory',
    'click @ui.gamingInfo': 'clickGamingInfo'
  },
  behaviors: [svs.player_login.behaviors.Navigation],

  onAttach() {
    this.clickGamingInfo();
    this.getUI('gamingLimits').one('click', () => {
      this.showChildView('gamingLimits', new svs.player_login.views.GamingLimits({
        el: '#gaming-limits > div',
        returnUrl: this.model.get('returnUrl')
      }));
    });
    this.getUI('gamingHistory').one('click', () => {
      this.showChildView('gamingHistory', new svs.player_login.views.GamingHistory({
        el: '#gaming-history > div',
        returnUrl: this.model.get('returnUrl')
      }));
    });
  },

  clickGamingInfo() {
    svs.components.analytics.trackEvent({
      action: 'översikt',
      category: 'login-info',
      opt_label: 'inloggning'
    });
  },

  clickGamingLimits() {
    svs.components.analytics.trackEvent({
      action: 'spelkoll',
      category: 'login-info',
      opt_label: 'gränser'
    });
  },

  clickGamingHistory() {
    svs.components.analytics.trackEvent({
      action: 'spelhistorik',
      category: 'login-info',
      opt_label: 'historik'
    });
  }

});
 })(window);